import store from '@/store';

export default (to, from, next) => {
    const is_whats_new_allowed = store.getters.is_app_whats_new_allowed;

    return {
        allow: is_whats_new_allowed,
        redirect: { name: 'not-found' },
    }
};
